module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/sec03_pc_8b799b3a62f6415da2973e6bc02a1e2f.jpg";